var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmergencyFacilityNswPoliceServiceStation = function SvgEmergencyFacilityNswPoliceServiceStation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004ABC",
    fillRule: "evenodd",
    d: "M6.667 7.833v5h5v5h-5v-5h-5v-5zm0-1.666H0V19.5h13.333V6.167zm11.829 10.586V19.5h-2.39v-9.394h4.05c.699 0 1.307.138 1.823.416.517.274.916.66 1.198 1.159.287.495.43 1.079.43 1.751v.013c0 .669-.143 1.252-.43 1.752a2.92 2.92 0 0 1-1.198 1.152c-.516.27-1.124.404-1.823.404zm0-4.812h1.08c.509 0 .904.126 1.186.378.286.252.43.623.43 1.113v.013c0 .486-.144.857-.43 1.114-.282.256-.677.384-1.185.384h-1.081z",
    clipRule: "evenodd"
  })));
};
export default SvgEmergencyFacilityNswPoliceServiceStation;